const Contacts: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="flex w-full flex-col items-center gap-y-5 md:mx-auto md:max-w-[500px] md:flex-row md:flex-wrap md:gap-y-0 lg:w-[calc(25%)] lg:flex-col">
    {children}
  </div>
);

export default Contacts;
